var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddRbdmHamMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9433 13.52C18.5947 13.52 19.9333 14.9169 19.9333 16.64V17.68C19.9333 21.7806 16.2267 26 9.96667 26C3.70662 26 0 21.7806 0 17.68V16.64C0 14.9169 1.33867 13.52 2.99 13.52H16.9433ZM9.96667 0C12.9941 0 15.4483 2.56093 15.4483 5.72C15.4483 8.87907 12.9941 11.44 9.96667 11.44C6.93923 11.44 4.485 8.87907 4.485 5.72C4.485 2.56093 6.93923 0 9.96667 0Z",
    fill: "#8DC63F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRbdmHamMenu);
export default __webpack_public_path__ + "static/media/Add_RBDM_ham_menu.61c240cce514c51449a911be00619692.svg";
export { ForwardRef as ReactComponent };